/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types'
import React from 'react'

import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '../link'

import {styleConfigChakraKeys} from '../../constants'
import LinksList from '../links-list'

const FooterAccordion = ({lists}) => {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.footerAccordion)

    return (
        <Accordion
            id="footer-accordion"
            allowMultiple
            maxWidth={'896px'}
            flex={[1, 1, 1, 5]}
            {...styles.accordion}
        >
            {lists &&
                lists.map((listCollectionItem, index) => (
                    <AccordionItem key={index} {...styles.accordionItem}>
                        <h2>
                            <AccordionButton
                                height="64px"
                                {...styles.accordionButton}
                            >
                                <Box
                                    flex="1"
                                    textAlign="left"
                                    fontWeight="bold"
                                    fontSize="lg"
                                    {...styles.accordionHeading}
                                >
                                    {listCollectionItem.heading}
                                </Box>
                                <div>
                                    <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 1L7 7L13 1"
                                            stroke="black"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            </AccordionButton>
                        </h2>
                        <AccordionPanel mb={6} mt={4} mx={0} paddingStart={0}>
                            <LinksList
                                key={index}
                                links={listCollectionItem.itemsCollection.items}
                            />
                        </AccordionPanel>
                    </AccordionItem>
                ))}
        </Accordion>
    )
}

FooterAccordion.propTypes = {
    lists: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string,
            headingType: PropTypes.string,
            itemsCollection: PropTypes.shape({
                items: PropTypes.arrayOf(
                    PropTypes.shape({
                        items: PropTypes.arrayOf(
                            PropTypes.shape({
                                ...Link.propTypes
                            })
                        )
                    })
                )
            })
        })
    )
}

export default FooterAccordion
